import React from "react";
//#region types
import { TitleSmallProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const TitleSmall: React.FC<TitleSmallProps> = (props) => {
  return (
    <Grid item className={clsx(cssExports.titleSmall, props.className)}>
      {LocalizationHelperInstance.getFormattedMessage(props.title)}
    </Grid>
  );
};

export default TitleSmall;
